import React from 'react';
import './styles.css';
import {Notification} from '../../../../data/models/Notifications/Invitation';
import {notificationsText} from '../notificationsText';
import InvitationNotificationUserProfile from '../component/InvitationNotificationUserProfile';
import {notificationTimeTextConvertor} from '../../../../utils/notificationTimeTextConvertor';
import TablePagination from '../../../../uiToolkit/TablePagination';
import {NOTICIATIONS_PAGE_SIZE} from '../container/NotificationsUserProfileContainer';

interface Props {
  notifications: Notification[];
  seenNotifications: Notification[];
  onDeny: (invitationId: string, notificationId: string) => void;
  onSeenNotification: (notificationId: string) => void;
  onViewCourse: (courseId: string, notificationId: string) => void;
  onViewWorkspace: (workspaceId: string, notificationId: string) => void;
  onViewCoursePreview: (
    courseId: string,
    workspaceId: string,
    notificationId: string,
  ) => void;
  pagesCount: number;
  currentPage: number;
  onPageChange: (page: number) => void;
}

const NotificationsUserProfileUI = React.memo(
  ({
    notifications,
    onDeny,
    onSeenNotification,
    onViewCourse,
    onViewWorkspace,
    seenNotifications,
    onViewCoursePreview,
    pagesCount,
    currentPage,
    onPageChange,
  }: Props) => {
    if (notifications.length === 0 && seenNotifications.length === 0) {
      return (
        <div className="UserProfileNotificationEmptyState">
          <h3>{notificationsText.noNotifications}</h3>
        </div>
      );
    }

    return (
      <div className="NotificationsUserProfile">
        {notifications.length ? (
          <div className="NotificationsSectionHeader">
            <p>{notificationsText.newNotifications}</p>
          </div>
        ) : null}
        {notifications.map((notification: Notification, index: number) => (
          <li key={index}>
            <InvitationNotificationUserProfile
              title={notification.title}
              dateSubtitle={notificationTimeTextConvertor(
                notification.dateCreated,
              )}
              onViewCoursePreview={() =>
                onViewCoursePreview(
                  notification.entityId,
                  notification.organizationId!,
                  notification.id,
                )
              }
              icon={notification.organizationAvatarUrl}
              onDeny={() => onDeny(notification.entityId, notification.id)}
              onSeenNotification={() => onSeenNotification(notification.id)}
              type={notification.type}
              onViewCourse={() =>
                onViewCourse(notification.entityId, notification.id)
              }
              onViewWorkspace={() =>
                onViewWorkspace(notification.organizationId!, notification.id)
              }
              description={notification.description}
            />
          </li>
        ))}
        {seenNotifications.length ? (
          <div className="NotificationsSectionHeader">
            <p>{notificationsText.seenNotifications}</p>
          </div>
        ) : null}
        {seenNotifications.map((notification: Notification, index: number) => (
          <li key={index}>
            <InvitationNotificationUserProfile
              title={notification.title}
              dateSubtitle={notificationTimeTextConvertor(
                notification.dateCreated,
              )}
              onViewCoursePreview={() =>
                onViewCoursePreview(
                  notification.entityId,
                  notification.organizationId!,
                  notification.id,
                )
              }
              icon={notification.organizationAvatarUrl}
              onDeny={() => onDeny(notification.entityId, notification.id)}
              onSeenNotification={() => onSeenNotification(notification.id)}
              type={notification.type}
              onViewCourse={() =>
                onViewCourse(notification.entityId, notification.id)
              }
              onViewWorkspace={() =>
                onViewWorkspace(notification.organizationId!, notification.id)
              }
              seen
              description={notification.description}
            />
          </li>
        ))}
        {seenNotifications.length ? (
          <div>
            <TablePagination
              rowsPerPage={NOTICIATIONS_PAGE_SIZE}
              rowCount={pagesCount * NOTICIATIONS_PAGE_SIZE}
              currentPage={currentPage + 1}
              onChangePage={page => onPageChange(page - 1)}
            />
          </div>
        ) : null}
      </div>
    );
  },
);

export default NotificationsUserProfileUI;
